import { Routes } from '@angular/router';

import { SaisineComponent } from './saisine.component';
import { SaisineEditComponent } from './saisine-edit.component';
import { SaisineDetailComponent } from './saisine-detail.component';
import {UserRouteAccessService} from '../../shared/auth/user-route-access-service';

export const saisineRoute: Routes = [
  {
    path: 'saisines',
    component: SaisineComponent,
    data: {
        authorities: ['ROLE_MINISTRY', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN', 'ROLE_SCHOOL_MANAGER', 'ROLE_SCHOOL_CONSULT'],
        pageTitle: 'tmmsaisineApp.saisine.home.titleTab'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'ma-saisine',
    component: SaisineEditComponent,
    data: {
        authorities: ['ROLE_STUDENT'],
        pageTitle: 'tmmsaisineApp.saisine.home.createOrEditLabel'
    },
    canActivate: [UserRouteAccessService]
  }, {
    path: 'saisines/:id',
    component: SaisineDetailComponent,
    data: {
        authorities: ['ROLE_MINISTRY', 'ROLE_ACADEMICREGIONRECTOR', 'ROLE_ACADEMICRECTOR', 'ROLE_SCHOOL_ADMIN', 'ROLE_SCHOOL_MANAGER', 'ROLE_SCHOOL_CONSULT'],
        pageTitle: 'tmmsaisineApp.saisine.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine.route.ts